import Cookies from "js-cookie";
import config from "../../config";

const hasRole = (user, roleName) => {
  const role = user?.rol;

  if (typeof role === "string") {
    return role.includes(roleName);
  }

  if (Array.isArray(role)) {
    return role.some(x=> x.includes(roleName));
  }

  const roleFlag = roleName.charAt(0).toUpperCase() + roleName.slice(1);
  return role?.[roleName] === true || role?.[`is${roleFlag}`] === true;
};

export default {
  getConfig() {
    return config;
  },
  vtcFetch(url, dato,api) {    
    const myHeaders = new Headers();

    let urlc ="";
   
    if(!api){
      urlc = config.urlAPI + url;  
      console.log("BUSCANDO URL",urlc)
    }else{
      urlc = process.env.VUE_APP_API_URL + url;
    }
    

    let envio = null;
    let esForm = dato instanceof FormData;
    if (!esForm) {
      envio = JSON.stringify(dato);
      myHeaders.append("Content-Type", "application/json");
    } else {
      envio = dato;
    }

    let tk = this.getUserToken();
    if (tk !== null) myHeaders.append("Authorization", tk);

    return fetch(urlc, {
      method: "POST",
      headers: myHeaders,
      body: envio,
    })
      .then((response) => response.json())
      .then((data) => {
        //Manejar codigo de respuesta, etc
        if (data.exitoso === true) {
          return data.data;
        } else {
            throw { codigo: data.codigo, data: data.data };
        }
      });
  },
  setUserToken(tk){
    Cookies.set("userToken", tk);
  },
  setUsuarioLogueado(usuario) {
    Cookies.set("userLogged", JSON.stringify(usuario));
  },
  setNameLogueado(name) {
    Cookies.set("nameUser", name);
  },
  getNameLogueado() {
    let name = Cookies.get("nameUser");
    if (name !== "" && name !== null && name !== undefined) {
      return name;
    }
    return null;
  },
  getUsuarioLogueado() {
    console.log("buscando usuario");
    let usr = Cookies.get("userLogged");
  
    if (usr !== "" && usr !== null && usr !== undefined) {
      const user = JSON.parse(Cookies.get("userLogged"));
        user.isAdmin = hasRole(user, "admin") || hasRole(user, "consultant")
        user.isConsultant = hasRole(user, "consultant")
      return user
    }
    return null;
  },
  isConsultant() {
    return hasRole(this.getUsuarioLogueado(), "consultant");
  },

  isAdminOrSuperAdmin() {

    if (hasRole(this.getUsuarioLogueado(), "admin")) return true
    if (hasRole(this.getUsuarioLogueado(), "superadmin")) return true

    return false

  },

  getUserToken() {
    let u = Cookies.get("userToken");
    if (u == null) return null;
    return u; 
  },
  deleteUserLogueado() {
    Cookies.remove("userToken");
    Cookies.remove("userLogged");
    Cookies.remove("nameUser");
  },

  isMobile() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      return true;
    } else {
      return false;
    }
  },

  /*
  1,2,(9)
  3,4(10)
  5,6
  7
  8(11)
  */

  isJVorDTS(id) {//incluye V2, muchos cambios cambiar el nombre
    let i = parseInt(id);
    if (i == 1 || i == 2 || i == 3 || i == 4  || i == 7 || i == 8 || i == 9 || i == 10 || i == 11) {
      return true;
    } else {
      return false;
    }
  },
  isJV(id) {//incluye V2, muchos cambios cambiar el nombre
    let i = parseInt(id);
    if (i == 1 || i == 2 || i == 7 || i == 8 || i == 9 || i == 11) {
      return true;
    } else {
      return false;
    }
  },
  isDTS(id) {
    let i = parseInt(id);
    if (i == 3 || i == 4  || i == 10 ) {
      return true;
    } else {
      return false;
    }
  },
  isHB(id) {
    let i = parseInt(id);
    if (i == 5 || i == 6) {
      return true;
    } else {
      return false;
    }
  },
  isV2(id){
    let i = parseInt(id);
    if(i == 7 || i == 8 || i == 11) return true;
    return false;
  },
  isJustV2622(id){
    let i = parseInt(id);
    if(i == 7) return true;
    return false;
  },
  isJustH6V2(id){
    let i = parseInt(id);
    if(i == 8 || i == 11) return true;
    return false;
  },
  isNCC2019(id){
    if(id == 1 || id == 3 || id ==5 || id ==7 || id == 8 || id == 11){ // solo aplicatambién para h6v2
      return true;
    }
    return false;
  },
  pasarFechaAYYYYMMDD(fecha, separador) {
    const year = fecha.getFullYear()
    const month = String(fecha.getMonth() + 1).padStart(2, '0') // Months are zero-based
    const day = String(fecha.getDate()).padStart(2, '0')
  
    if (separador == '') separador = '-'
  
    return `${year}${separador}${month}${separador}${day}`
  }
  
};
